import { render, staticRenderFns } from "./ViewAllRecords.vue?vue&type=template&id=457fc106&"
import script from "./ViewAllRecords.vue?vue&type=script&lang=js&"
export * from "./ViewAllRecords.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports